<template>
  <rest-page :key="key" ref="restPage" :fetch-endpoint="fetchEndpoint">
    <rest-form
      ref="form"
      :after-save="afterSave"
      :disabled="false"
      :model="model"
      :rules="rules"
      :save-endpoint="saveEndpoint"
    >
      <page-header-new
        :breadcrumbs="breadcrumbs"
        :title="$t('ApplicationsPush_Title', { app_name: applicationName })"
      >
        <template slot="actions">
          <el-button
            v-if="model && model.type !== ApplicationTypes.web"
            icon="el-icon-check"
            plain
            type="primary"
            @click="save"
          >
            <span v-if="isAppPushComplete">
              {{ $t('RestForm_Update') }}
            </span>
            <span v-else>{{ $t('RestForm_Save') }}</span>
          </el-button>
        </template>
      </page-header-new>
      <page-content>
        <push-settings-ios
          v-if="model && model.type === ApplicationTypes.ios"
          :date-format="dateFormat"
          :model="model"
          :readonly="readonly"
        />
        <push-settings-android
          v-if="
            model &&
              model.type === ApplicationTypes.android &&
              model.huawei_app_id === null
          "
          :date-format="dateFormat"
          :model="model"
          :readonly="readonly"
        />
        <push-settings-huawei
          v-if="
            model &&
              model.type === ApplicationTypes.android &&
              model.huawei_app_id !== null
          "
          :date-format="dateFormat"
          :model="model"
          :readonly="readonly"
        />
        <push-settings-web
          v-if="model && model.type === ApplicationTypes.web"
          :date-format="dateFormat"
          :model="model"
          :readonly="readonly"
          :save="save"
        />
      </page-content>
    </rest-form>
  </rest-page>
</template>

<script>
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestPage from '@/common/components/rest/RestPage'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PushSettingsIos from '@/modules/settings/components/PushSettingsIos'
import { ApplicationTypes } from '@/modules/account/enum/ApplicationEnum'
import PageContent from '@/common/components/page/PageContent'
import i18n from '@/core/utils/I18n'
import moment from 'moment'
import RestForm from '@/common/components/rest/RestForm'
import PushSettingsAndroid from '@/modules/settings/components/PushSettingsAndroid'
import PushSettingsHuawei from '@/modules/settings/components/PushSettingsHuawei'
import PushSettingsWeb from '@/modules/settings/components/PushSettingsWeb'

export default {
  name: 'ApplicationPushPage',
  components: {
    PushSettingsWeb,
    PushSettingsAndroid,
    PushSettingsHuawei,
    RestForm,
    PageContent,
    PushSettingsIos,
    PageHeaderNew,
    RestPage
  },

  data() {
    return {
      key: '',
      ApplicationTypes,
      model: null
    }
  },

  computed: {
    applicationName() {
      if (this.model && this.model.name) {
        return this.model.name
      }
      return this.$t('ApplicationsChannels_ActivationOk')
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `applications/${this.$route.query.id}`,
        params: {
          expand:
            'webpushCode,webpushServiceWorkerContent,webpushManifestContent,webpushWindowContent,' +
            'webpushFrameContent,safariCertificateExpiryDate,iosProductionCertificateExpiryDate,' +
            'iosSandboxCertificateExpiryDate,providerDomain'
        },
        handler: data => {
          this.model = data
        }
      })
    },
    breadcrumbs() {
      return [
        {
          label: this.$t('ApplicationList_Title'),
          route: projectRoute({
            name: 'Applications'
          })
        },
        {
          label: this.applicationName,
          route: projectRoute({
            name: 'ApplicationChannels',
            query: {
              id: this.$route.query.id,
              project_id: this.$route.query.project_id
            }
          })
        },
        {
          label: this.$t('ApplicationsPush_BreadCrumb_Title')
        }
      ]
    },
    dateFormat() {
      const locale = i18n.locale === 'en' ? 'en-GB' : i18n.locale
      return moment.localeData(locale).longDateFormat('llll')
    },
    readonly() {
      return !this.$can('updateProject')
    },
    saveEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint(
          {
            method: 'patch',
            url: `applications/${this.$route.query.id}`
          },
          this.project_id || this.$route.query.project_id
        )
      } else {
        return {}
      }
    },
    rules() {
      return {}
    },
    isAppPushComplete() {
      return (
        this.model &&
        ((this.model.type === 'ios' &&
          this.model.ios_production_key &&
          this.model.ios_sandbox_key) ||
          (this.model.type === 'android' && this.model.android_key))
      )
    }
  },
  methods: {
    save() {
      this.$refs['form'].save()
    },
    afterSave(data, finishLoading) {
      this.key = new Date().getTime() // refresh the table items
      finishLoading.apply()
    },
    defaultModel() {
      if (this.$route.query.id) {
        return null
      } else {
        return {
          type: this.$route.query.type,
          project_id: this.$route.query.project_id
        }
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/account/pages/ApplicationPushPage.vue